import { useEffect } from 'react';

export default (onCloseButtonClick, isApplicable = true) => {
  useEffect(() => {
    if (isApplicable) {
      const handleKeyDown = (event) => {
        if (event.key === 'Escape') {
          onCloseButtonClick();
        }
      };

      document.addEventListener('keydown', handleKeyDown);

      return () => {
        document.removeEventListener('keydown', handleKeyDown);
      };
    }
  }, [onCloseButtonClick, isApplicable]);
};
